/**
 * ============================================================================
 * ADMIN DASHBOARD LAYOUT COMPONENT
 * ============================================================================
 * Same structure as UserDashboardLayout: Header, Sidebar, Footer (green/black theme)
 */

import React, { useState } from 'react';
import AdminHeader from './AdminHeader';
import AdminSidebar from './AdminSidebar';
import AdminFooter from './AdminFooter';
import '../../styles/landing.css';
import '../../styles/global.css';
import '../../styles/animations.css';

/**
 * Admin Layout Component
 * @param {Object} props
 * @param {React.ReactNode} props.children - Page content
 * @param {boolean} props.hideSidebar - Hide sidebar (optional)
 * @param {boolean} props.hideFooter - Hide footer (optional)
 * @returns {JSX.Element}
 */
const AdminLayout = ({ children, hideSidebar = false, hideFooter = false }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex flex-col">
      <AdminHeader
        onMenuToggle={() => setSidebarOpen(!sidebarOpen)}
        sidebarOpen={sidebarOpen}
      />

      <div className="flex flex-1 overflow-hidden">
        {!hideSidebar && (
          <AdminSidebar
            isOpen={sidebarOpen}
            onClose={() => setSidebarOpen(false)}
          />
        )}

        <main className={`flex-1 overflow-y-auto ${!hideSidebar ? 'lg:ml-0' : ''}`}>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-5">
            {children}
          </div>
        </main>
      </div>

      {!hideFooter && <AdminFooter />}
    </div>
  );
};

export default AdminLayout;
